import { Box } from '@mui/material';
import { memo } from 'react';

import { barItemStyles } from './InfoStepper.styling';

interface ProgressBarItemProps {
  index: number;
  isCompleted: boolean;
}

export const ProgressBarItem = memo(
  ({ index, isCompleted }: ProgressBarItemProps) => {
    return (
      <Box
        sx={barItemStyles(isCompleted)}
        aria-label={`Step ${index + 1}${isCompleted ? ' completed' : ''}`}
        data-testid={`progress-bar-item-${index}`}
      />
    );
  },
);

ProgressBarItem.displayName = 'ProgressBarItem';
